module.exports = {
      id: "ic-highest-lowest-dark-active-usage",
      viewBox: "0 0 160 120",
      url: __webpack_public_path__ + "sprite-2c53a1.smartcharts.svg#ic-highest-lowest-dark-active-usage",
      toString: function () {
        return this.url;
      }
    }